import { Box, Heading, Skeleton, VStack } from "@chakra-ui/react";
import React from "react";
import SectionContainer from "../../components/layout/SectionContainer";
import type { ICoachesPageSectionProps } from "./interfaces";
import useTranslationConstants from "lib/utils/constants";

const HeaderSection = ({ data, loading }: ICoachesPageSectionProps) => {
  const { LINKS } = useTranslationConstants();

  return (
    <Box
      bgImage={LINKS.images.coachBackground}
      bgColor="brandOrange.500"
      bgSize="cover"
      bgRepeat="no-repeat"
      pos="relative"
      backgroundBlendMode="multiply"
    >
      <SectionContainer
        pos="relative"
        zIndex="docked"
        h="full"
        pt={24}
        pb={48}
        px={12}
        mt={["80px", "80px", "80px", "100px"]}
      >
        <VStack spacing={4} h="full" justify="center">
          <Skeleton isLoaded={!loading}>
            <Heading
              textAlign="center"
              textTransform="uppercase"
              as="h1"
              size="xl"
              color="white"
            >
              {data?.coach_by_pk?.name}
            </Heading>
          </Skeleton>
        </VStack>
      </SectionContainer>
    </Box >
  );
};

export default HeaderSection;
